module.exports = __webpack_public_path__ + "img/451081.493c0e2c.png";